import axios from './../plugins/private-api-axios'

export const remotePlaybackService = {
    urlPrefix: '/remotePlayback',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getLiveView (vehicleId, channel) {
        try {
            return await axios.post(`${this.urlPrefix}/requestVehicleLiveView/${vehicleId}`, {
                id: vehicleId,
                channel: channel
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getRemotePlayback (vehicleId, channel, startDate, endDate) {
        try {
            return await axios.post(`${this.urlPrefix}/requestVehicleRemotePlayback/${vehicleId}`, {
                id: vehicleId,
                channel: channel,
                startDateTime: startDate,
                endDateTime: endDate
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getRemotePlaybackCalendar (vehicleId, recordingDay = null) {
        let data = {
            id: vehicleId
        }

        if (null !== recordingDay) {
            data.recordingDay = recordingDay
        }

        try {
            return await axios.post(`${this.urlPrefix}/requestVehicleRecordingCalendar/${vehicleId}`, data, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateRemotePlaybackService = (accessToken) => {
    remotePlaybackService.config.headers.Authorization = accessToken
}

export default remotePlaybackService
